import { useState } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { config } from '../config';

const nav = [
  ['/how-it-works', 'How it works'],
  ['/pricing', 'Pricing'],
  ['/states', 'State roadmap'],
  ['/help', 'Help']
] as const;

export function PublicLayout() {
  const auth = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  const workspacePath = auth.identity?.internal ? '/ops' : '/app';
  return <div className="site-shell">
    <a className="skip-link" href="#main-content">Skip to content</a>
    <header className="public-header">
      <Link className="brand" to="/" aria-label={`${config.appName} home`}>
        <span className="brand-mark" aria-hidden="true">P</span>
        <span>{config.appName}</span>
      </Link>
      <nav aria-label="Primary navigation">
        {nav.map(([to, label]) => <NavLink key={to} to={to}>{label}</NavLink>)}
      </nav>
      <button className="menu-button" type="button" aria-label={menuOpen ? 'Close menu' : 'Menu'} aria-expanded={menuOpen} aria-controls="mobile-navigation" onClick={() => setMenuOpen((open) => !open)}>
        <span aria-hidden="true">{menuOpen ? '×' : '☰'}</span><span className="menu-label">Menu</span>
      </button>
      <div className="header-actions">
        {auth.loading ? null : auth.identity ? <Link className="button button-small" to={workspacePath}>Open PayRight</Link> : <><Link className="text-link" to="/login">Log in</Link><Link className="button button-small" to="/signup">Start free</Link></>}
      </div>
      {menuOpen && <nav id="mobile-navigation" className="mobile-nav" aria-label="Mobile navigation">
        {nav.map(([to, label]) => <NavLink key={to} to={to} onClick={closeMenu}>{label}</NavLink>)}
        <NavLink to="/contact" onClick={closeMenu}>Contact</NavLink>
        {auth.loading ? null : auth.identity ? <NavLink to={workspacePath} onClick={closeMenu}>Open PayRight</NavLink> : <NavLink to="/login" onClick={closeMenu}>Log in</NavLink>}
      </nav>}
    </header>
    <main id="main-content"><Outlet /></main>
    <footer className="public-footer">
      <div><strong>{config.appName}</strong><p>Know what is due, move notice work forward, and find proof fast.</p></div>
      <div><strong>Explore</strong><Link to="/how-it-works">How it works</Link><Link to="/help">Help & workflows</Link><Link to="/contact">Contact</Link></div>
      <div><strong>Legal</strong><Link to="/terms">Terms</Link><Link to="/privacy">Privacy</Link><Link to="/cookies">Cookies</Link><Link to="/accessibility">Accessibility</Link><Link to="/disclaimer">Legal disclaimer</Link></div>
      <p className="footer-note">PayRight is a document and workflow platform, not a law firm. This site does not provide legal advice. The working name has not been legally cleared.</p>
    </footer>
  </div>;
}
